<!--消费记录-->
<template>
  <div class="com-table balance border">
    <div class="com-title pr">数据分析</div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <!-- <el-tab-pane label="词性分析" name="first">
        <NaturePie></NaturePie>
      </el-tab-pane> -->
      <el-tab-pane label="地域分析" name="second" lazy=’true’>
        <ProvincePie></ProvincePie>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
  import NaturePie from '@/components/client/NaturePie'
  import ProvincePie from '@/components/client/ProvincePie'
  export default {
    components: {
      NaturePie,
      ProvincePie
    },
    data () {
      return {
        activeName: 'second'
      }
    }
  }
</script>
<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/client/IntelAnalysis.vue